import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface StatsCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}
export function StatsCard({
  icon,
  label,
  value,
  trend
}: StatsCardProps) {
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-296" data-mp="2qtp0xtqxg50c">
      <div className="flex items-start justify-between" data-id="element-297" data-mp="2vsihxw5fae59">
        <div className="flex-1" data-id="element-298" data-mp="2vryww6kh79n0">
          <div className="text-sm font-medium text-gray-600 mb-1" data-id="element-299" data-mp="2vuut9qgodq9c">{label}</div>
          <div className="text-3xl font-bold text-gray-900" data-id="element-300" data-mp="2zsaj3nshli0l">
            {value.toLocaleString()}
          </div>
          {trend && <div className={`flex items-center gap-1 mt-2 text-sm ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-301" data-mp="39s1b9itkrkxi">
              {trend.isPositive ? <TrendingUpIcon size={16} data-id="element-302" data-mp="1fe8owoq8k183" /> : <TrendingDownIcon size={16} data-id="element-303" data-mp="1feikqsxyp2lp" />}
              <span data-id="element-304" data-mp="23tkm0htw6c1l">{Math.abs(trend.value)}%</span>
            </div>}
        </div>
        <div className="w-12 h-12 bg-[#1B5E20] bg-opacity-10 rounded-lg flex items-center justify-center text-[#1B5E20]" data-id="element-305" data-mp="1z22oy4uzovlw">
          {icon}
        </div>
      </div>
    </div>;
}